import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[kui-side-panel-span]',
})
export class KuiSidePanelSpanDirective {
  @HostBinding('class.ml-auto') leftMarginAuto = true;
}
